'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = apiActionCreatorFactory;

var _utils = require('./utils');

var _parseUrl = require('./parseUrl');

var _parseUrl2 = _interopRequireDefault(_parseUrl);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var normalizeUrl = function normalizeUrl(url, params) {
  return typeof url === 'function' ? url(params) : url;
};

function apiActionCreatorFactory(config, type) {
  var configPayload = config.payload,
      configUrl = config.url,
      configMeta = config.meta,
      restMeta = _objectWithoutProperties(config, ['payload', 'url', 'meta']);

  var asyncTypes = (0, _utils.toAsyncTypes)(type);

  function apiActionCreator(payload, meta) {
    var url = normalizeUrl(configUrl, meta);

    var finalMeta = _extends({}, restMeta, configMeta || {}, meta || {});

    return {
      type: asyncTypes,
      payload: payload !== undefined ? payload : configPayload,
      meta: _extends({}, finalMeta, {
        url: (0, _parseUrl2.default)(url, finalMeta)
      })
    };
  }

  Object.assign(apiActionCreator, config);
  return apiActionCreator;
}